export const AUTH_TAB_SYNC_MODAL_CLASS = 'auth-tab-sync-modal';
